module.exports = __webpack_public_path__ + "media/4.3cdc2fb4.wav";